export const qs = (selector, root = document) => root.querySelector(selector);
export const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

export const toggleHidden = (element, shouldHide) => {
  if (!element) return;
  element.hidden = shouldHide;
};

export const createElement = html => {
  const template = document.createElement('template');
  template.innerHTML = html.trim();
  return template.content.firstElementChild;
};

export const delegate = (root, selector, eventName, handler) => {
  root.addEventListener(eventName, event => {
    const target = event.target.closest(selector);
    if (target && root.contains(target)) {
      handler(event, target);
    }
  });
};
